import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Box, Button, Typography } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CustomModal from '../../../../components/modal/CustomModal';
import { setUnitArchive } from '../../../../actions/units.actions';

const ArchiveUnit = ({ unitId, renderOpen, handleSuccess, unitStatus }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const modalRef = useRef(null);

  const handleArchive = (e) => {
    e && e.stopPropagation();
    dispatch(setUnitArchive(unitId))
      .then(() => {
        enqueueSnackbar('Unit was archived', {
          variant: 'success',
        });
        modalRef.current.close();
        history.push('/admin/units/');
        handleSuccess && handleSuccess();
      })
      .catch((error) => {
        console.error('Error archiving unit:', error);
        const errorMessage = error?.response?.data?.detail || error?.message || 'Failed to archive unit. Please try again.';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
        });
      });
  };

  const handleClose = (e) => {
    e && e.stopPropagation();
    modalRef.current.close();
  };

  return (
    <>
      {unitStatus === 'archived' ? (
        <Box style={{ height: 36 }}></Box>
      ) : (
        <CustomModal renderOpen={renderOpen} ref={modalRef}>
          <Box textAlign="center">
            <Box>
              <ErrorOutlineIcon
                style={{ width: 67, height: 67, color: 'red' }}
              />
            </Box>
            <Typography variant="h6" color="primary">
              <Box fontWeight="bold">
                Warning: Unit archive cannot be undone!
              </Box>
            </Typography>
            <Box mt={2} />
            <Typography variant="body1">
              Are you sure you want to archive the unit along with tenant and
              permit information?
            </Typography>
            <Box mt={1} />
            <Typography variant="body1">
              To{' '}
              <Box component="span" fontWeight="bold">
                transfer
              </Box>{' '}
              a unit{' '}
              <Box component="span" fontWeight="bold">
                Do Not Archive
              </Box>
              , select the pencil icon next to the unit number to edit the unit.
            </Typography>
            <Box mt={1} />
            <Typography variant="body1">
              ¿Está seguro de que desea archivar la unidad junto con la
              información del inquilino y de los permisos?
            </Typography>
            <Box mt={1} />
            <Typography variant="body1">
              Para{' '}
              <Box component="span" fontWeight="bold">
                transferir
              </Box>{' '}
              una unidad{' '}
              <Box component="span" fontWeight="bold">
                No Archive
              </Box>
              , seleccione el icono del lápiz junto al número de unidad para
              editarla.
            </Typography>
            <Box mt={7}>
              <Button
                id='unit_archive_cancel_button'
                variant="outlined"
                size="large"
                color="secondary"
                onClick={(e) => handleClose(e)}
              >
                Cancel
              </Button>
              <Box mr={2} component="span" />
              <Button
                id='unit_archive_confirm_button'
                variant="contained"
                size="large"
                style={{
                  color: '#fff',
                  backgroundColor: '#d32f2f',
                }}
                onClick={(e) => handleArchive(e)}
              >
                Archive
              </Button>
            </Box>
          </Box>
        </CustomModal>
      )}
    </>
  );
};

export default ArchiveUnit;
